import React from 'react'
import { connect } from 'react-redux'
import Unauthorized from '../unauthorized'

/**
 * HOC to guard pages/components based on feature access
 * Usage: export default withFeatureAccess('feature_name')(MyComponent)
 */
const withFeatureAccess = (featureName) => (Component) => {
  const WrappedComponent = ({ appSettings, ...props }) => {

    const hasFeature = appSettings?.activeFeatures?.some(
      (feature) => feature.featureName === featureName && feature.isActive !== false
    )

    if (!hasFeature) {
      console.warn(`Access denied for feature: ${featureName}`)
      return <Unauthorized />
    }

    return <Component {...props} />
  }

  return connect((state) => {
    return {
      appSettings: state.appSettingReducer || state.appSetting
    }
  })(WrappedComponent)
}

export default withFeatureAccess
